import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';

function Pricing() {
  const [email, setEmail] = useState('');
  const [licenseKey, setLicenseKey] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationResult, setVerificationResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const supabaseUrl = 'https://hthhxrlracyakuxktofg.supabase.co';
  const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh0dGh4cmxyYWN5YWt1eGt0b2ZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk4MTI0MjQsImV4cCI6MjA1NTM4ODQyNH0.8BpRQiLUxT3cYaDXdjKMrhkrjJOiM4iZQywDLKDyo5o';
  const supabase = createClient(supabaseUrl, supabaseAnonKey);

  // Lemon Squeezy Configuration
  const storeId = '155950';
  const premiumVariantId = '701917';
  const lifetimeVariantId = '701918';
  const lemonSqueezyApiKey = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NGQ1OWNlZi1kYmI4LTRlYTUtYjE3OC1kMjU0MGZjZDY5MTkiLCJqdGkiOiI2ZGU2NTM0ZGJlYzUxY2RkMzEzZjQ2NWQ5NTAxMmMwN2Q0YzQ0NjJiOGU1NzRmODhmZTk0ZTQ5OTI0ZjkzYWEwMWMwNzU1N2M4NDdhOTk1IiwiaWF0IjoxNzQwMTYyODg0LjU5NDIxMSIsIm5iZiI6MTc0MDE2Mjg4NC41OTQyMTUsImV4cCI6MjA1NTY5NTY4NC41NTQyMzE5NDksInN1YiI6IjQ0MTI0MDEiLCJzY29wZXMiOltdfQ.lT1wS3s16EQLK2vRzIeY6WqP-l9H2y3nL00k-N0g2qg1p_GqL334oF69Yq6v7K3N2y7Q_I1W17tI_iK2mN83s8z9K2-69K4Xn02V6n6L-d6XvE8v9E1t17e8g650yL9D8k3Q3T4yS9J6V63K2v10I7l-9w9i3n3l6K4K4a1P-m6s5u8y1P6u5i3o-8f2W4z4g-9j8f6v4a3o-6l1a0k9h1s3a6r1u7b7f1w0a-5o7s9k6j-2w8j1a3g8d6f4f6x9v4z7h5p4u9y1q4d-6z7b4t7q3k7n2i4m7n8r3f5k7o9g1a2t9w9d9e9y7q7q7w1t7t6s5r7u-u4o5m4q7r6s8s7a3j-6l2w3w9t2s8u3o3q1s1q7z8i7d8h7v7m3z4k7o7b6z9y5z7o1e8v4d5u6p8g1t8t1r5t4w1y9g6y4b7u3n5t1e9m6u8a1t9v7u5v7a3z8x1j7x9y3n4p6x2c4f7u8w8q';

  // Pricing Plans
  const pricingPlans = [
    {
      name: "Free",
      price: "$0",
      description: "Get started for free",
      features: [
        { name: "TXT/JSON Export", available: false },
        { name: "Bulk Export Chats", available: false },
        { name: "Bulk Delete Chats", available: false },
        { name: "Bulk Archive Chats", available: false },
        { name: "Bulk Unarchive Chats", available: false },
        { name: "Folders & Subfolders Creation", available: "Up to 2 Total Folders" },
        { name: "Prompts Creation", available: "Up to 2 Prompts" },
        { name: "Pinned Chats Creation", available: "Up to 2 Pinned Chats" },
        { name: "Sync Between Devices", available: true },
        { name: "Sync Between Browsers (Chrome, Firefox, Edge)", available: true },
        { name: "Word & Character Counter", available: true },
        { name: "Support Response Time", available: "Can take up to 72 hours" },
        { name: "Advanced Chat History Search", available: "Up to 5 Results" },
      ],
    },
    {
      name: "Premium",
      price: "$4.99",
      billing: "Billed Monthly",
      description: "Unlock all features",
      features: [
        { name: "TXT/JSON Export", available: true },
        { name: "Bulk Export Chats", available: true },
        { name: "Bulk Delete Chats", available: true },
        { name: "Bulk Archive Chats", available: true },
        { name: "Bulk Unarchive Chats", available: true },
        { name: "Folders & Subfolders Creation", available: "Unlimited Folders" },
        { name: "Prompts Creation", available: "Unlimited Prompts" },
        { name: "Pinned Chats Creation", available: "Unlimited Pinned Chats" },
        { name: "Sync Between Devices", available: true },
        { name: "Sync Between Browsers (Chrome, Firefox, Edge)", available: true },
        { name: "Word & Character Counter", available: true },
        { name: "Support Response Time", available: "Within 24 hours" },
        { name: "Advanced Chat History Search", available: "Unlimited Results" },
      ],
    },
    {
      name: "Lifetime",
      price: "$39.9",
      billing: "One-Time Payment",
      description: "One time payment and unlock all features",
      features: [
        { name: "TXT/JSON Export", available: true },
        { name: "Bulk Export Chats", available: true },
        { name: "Bulk Delete Chats", available: true },
        { name: "Bulk Archive Chats", available: true },
        { name: "Bulk Unarchive Chats", available: true },
        { name: "Folders & Subfolders Creation", available: "Unlimited Folders" },
        { name: "Prompts Creation", available: "Unlimited Prompts" },
        { name: "Pinned Chats Creation", available: "Unlimited Pinned Chats" },
        { name: "Sync Between Devices", available: true },
        { name: "Sync Between Browsers (Chrome, Firefox, Edge)", available: true },
        { name: "Word & Character Counter", available: true },
        { name: "Support Response Time", available: "Within 24 hours" },
        { name: "Advanced Chat History Search", available: "Unlimited Results" },
      ],
    },
  ];

  // Handler to Select a Pricing Plan
  const handleSelectPlan = (planName) => {
    let checkoutUrl;

    if (planName === "Premium") {
      checkoutUrl = `https://app.lemonsqueezy.com/checkout/${storeId}/variants/${premiumVariantId}`;
    } else if (planName === "Lifetime") {
      checkoutUrl = `https://app.lemonsqueezy.com/checkout/${storeId}/variants/${lifetimeVariantId}`;
    } else {
      console.warn("Invalid plan name:", planName);
      return;
    }

    window.location.href = checkoutUrl;
  };

  // Handler to Verify License
  const handleVerifyLicense = async () => {
    setIsVerifying(true);
    setVerificationResult(null);
    setErrorMessage('');

    try {
      const isValid = await validateLicense(licenseKey);

      if (isValid) {
        setVerificationResult(true);
        const { error } = await supabase
          .from('profiles')
          .update({ role: 'Premium' })
          .eq('email', email)
          .select();

        if (error) {
          console.error('Error updating profile:', error);
          setErrorMessage('Failed to grant premium access. Please contact support.');
        } else {
          setErrorMessage('Premium access granted!');
        }
      } else {
        setVerificationResult(false);
        setErrorMessage('Invalid license key.');
      }
    } catch (error) {
      console.error('Error:', error);
      setVerificationResult(false);
      setErrorMessage('An unexpected error occurred. Please contact support.');
    } finally {
      setIsVerifying(false);
    }
  };

  // Function to Validate License
  const validateLicense = async (licenseKey) => {
    try {
      const response = await fetch('https://api.lemonsqueezy.com/v1/licenses/validate', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${lemonSqueezyApiKey}`,
        },
        body: new URLSearchParams({ license_key: licenseKey }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('License validation failed:', errorData);
        throw new Error(`Lemon Squeezy API error: ${response.status} - ${errorData?.error || response.statusText}`);
      }

      const data = await response.json();
      return data.valid;
    } catch (error) {
      console.error('Error validating license:', error);
      setErrorMessage(`License validation failed: ${error.message}`);
      return false;
    }
  };

    const renderFeatureAvailability = (feature) => {
        if (feature.available === true) {
            return (
                <svg className="h-5 w-5 mx-auto text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
            );
        } else if (feature.available === false) {
            return (
                <svg className="h-5 w-5 mx-auto text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
            );
        } else {
            return <div className="text-sm">{feature.available}</div>;
        }
    };

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Choose the plan that's right for you
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
            Compare our plans and find the perfect fit for your needs.
          </p>
        </div>

        {/* Pricing Plans */}
        <div className="mt-12 space-y-4 lg:mt-16 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-6">
          {pricingPlans.map((plan, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="px-6 py-8 sm:p-10 sm:pb-8">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 tracking-tight">
                    {plan.name}
                  </h3>
                  <div className="mt-4 flex items-center justify-center">
                    <span className="text-5xl font-extrabold text-gray-900">{plan.price}</span>
                    {plan.billing && <span className="ml-2 text-xl text-gray-500">{plan.billing}</span>}
                  </div>
                  <p className="mt-2 text-sm text-gray-500">{plan.description}</p>
                </div>
                <ul className="mt-8 space-y-4">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center">
                      <div className="mr-3">
                          {renderFeatureAvailability(feature)}
                      </div>
                      <span className="text-gray-700">{feature.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="px-6 py-4 sm:px-10">
                {plan.name !== "Free" ? (
                  <button
                    onClick={() => handleSelectPlan(plan.name)}
                    className="block w-full bg-indigo-600 border border-transparent rounded-md py-3 px-5 text-center font-medium text-white hover:bg-indigo-700"
                  >
                    Select Plan
                  </button>
                ) : (
                  <button
                    className="block w-full bg-white border-2 border-indigo-600 rounded-md py-3 px-5 text-center font-medium text-indigo-600 hover:bg-indigo-50"
                  >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline mr-2">
                          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#4285F4" />
                          <path d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z" fill="#4285F4" />
                      </svg>
                    Add to Chrome
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* License Verification Form */}
        <div className="mt-16 bg-white rounded-lg shadow-md p-6 sm:p-8">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Verify Your License</h3>
          {errorMessage && <div className="mb-4 text-red-500">{errorMessage}</div>}
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email:
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  id="email"
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <div>
              <label htmlFor="licenseKey" className="block text-sm font-medium text-gray-700">
                License Key:
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  id="licenseKey"
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="Your license key"
                  value={licenseKey}
                  onChange={(e) => setLicenseKey(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="mt-6">
            <button
              type="button"
              onClick={handleVerifyLicense}
              disabled={isVerifying}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {isVerifying ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Verifying...
                </>
              ) : (
                'Verify License'
              )}
            </button>
          </div>

          {/* Display Verification Results */}
          {verificationResult === true && !errorMessage && (
            <div className="mt-4 text-green-500">License Valid!</div>
          )}
          {verificationResult === false && (
            <div className="mt-4 text-red-500">License Invalid!</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Pricing;